import React, {useState} from 'react';
import Button from "../UI/Button";
import Row from "../UI/Row";
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import useAuthCalls from "../../utilities/custom-hooks/auth-calls";
import {doPostTrialForUser} from "../../logic/subscriptions";
import Loading from "../UI/Loading";

const TrialStep = ({subscription, onSuccess}) => {

    const {user, selectedSubscription} = useRegistrationSteps();
    const [activationLoading, setActivationLoading] = useState(false);
    const {call} = useAuthCalls();

    const handleTrialActivation = async () => {
        setActivationLoading(true);
        if(user.id && selectedSubscription.id) {
            await call(() => doPostTrialForUser(user.id, selectedSubscription.id),
                (res) => {
                    if(res && res.subscription) {
                        onSuccess && onSuccess();
                    }
                },
                () => {
                    alert("Attivazione fallita")
                }
            )
        }
        setActivationLoading(false);
    }

    return (
        <div>
            <div className="mb-8">
                <div className="border-b w-full text-left">
                    <div className="font-bold">{subscription.name} - Prova gratuita di 15 giorni</div>
                    <div>{subscription.description}</div>
                </div>
                <Row className="justify-end gap-4">
                    <span className="line-through">{parseFloat(subscription.price).toFixed(2)} €</span>
                    <div className="font-bold text-right">GRATIS</div>
                </Row>

            </div>
            {activationLoading ?
                <Loading label="Attivazione in corso" />
                :
                <Button className="w-full" onClick={handleTrialActivation}>Attiva la prova gratuita</Button>
            }

        </div>
    );
};

export default TrialStep;